import template from './invoiceEditTimeEntryModal.html';
import controller from './invoiceEditTimeEntryModal.controller';

let InvoiceEditTimeEntryModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-warning animated zoomIn"
};

export default InvoiceEditTimeEntryModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceEditTimeEntryModal/invoiceEditTimeEntryModal.component.js